module.exports = __webpack_public_path__ + "static/media/31JFA4.00e630db.jpg";